import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'safeUrlGet'
})

export class SafeUrlGet implements PipeTransform {

    constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }

    transform(url): Observable<SafeUrl> {
        if (url) {
            return this.http.get(
                url, { responseType: 'blob', withCredentials: true }
            ).pipe(map(val => this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(val))));
        }
    }
}
